import { List, Text, Title } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";
import { useHistory } from "react-router-dom";

import { useInHomeCaseHistoryDataContext } from "../../ShiftDiscovery/useInHomeCaseHistoryDataContext";
import { CaseStatuses } from "../constants";
import { IN_HOME_CASE_DETAILS_PATH } from "../paths";
import { type CaseHistoryData, type CaseStatus } from "../types";
import { CaseHistoryListItem } from "./ListItem";

interface CaseHistoryListProps {
  cases: CaseHistoryData[];
  caseStatusFilter: CaseStatus;
}

export function CaseHistoryList(props: CaseHistoryListProps) {
  const { cases, caseStatusFilter } = props;
  const { setCaseHistoryData, generateModalPath } = useInHomeCaseHistoryDataContext();
  const history = useHistory();

  if (cases.length === 0) {
    return (
      <Stack sx={{ height: "100%", justifyContent: "center", alignItems: "center" }} spacing={5}>
        <Title
          semibold
          variant="h4"
          component="h3"
          sx={{ textWrap: "balance", textAlign: "center" }}
        >
          You have no {caseStatusFilter === CaseStatuses.OPEN ? "active" : "closed"} cases
        </Title>
        <Text
          semibold
          variant="body2"
          sx={{ paddingBottom: 8, textWrap: "balance", textAlign: "center" }}
        >
          Check back after{" "}
          {caseStatusFilter === CaseStatuses.OPEN ? "you've booked" : "you've completed"} a case!
        </Text>
      </Stack>
    );
  }

  return (
    <Stack width="100%" sx={{ overflowY: "scroll" }}>
      <List>
        {cases.map((caseData) => (
          <CaseHistoryListItem
            key={caseData.id}
            caseData={caseData}
            onClick={() => {
              setCaseHistoryData(caseData);
              history.push(generateModalPath(IN_HOME_CASE_DETAILS_PATH, { caseId: caseData.id }));
            }}
          />
        ))}
      </List>
    </Stack>
  );
}
